export default __webpack_public_path__ + "static/media/a93c128cf23fbc6e68d1ffc643fb1d1a.png";